import { MaybeRef } from 'vue'

export function useListItem<T>(list: Ref<T[]>, index: number, defaultValue: T) {
  return computed<T>({
    get: () => toValue(list)?.[index] ?? defaultValue,
    set: (value: T) => {
      toValue(list).splice(index, 1, value)
    }
  })
}
